export const INITIATE_OTP_PAGE_ID = 'initiateOtpScreen';
